import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { IServerResponse, IURLCheckerResponse } from './models';
import * as $ from 'jquery';

const CSS_CLASS_HIDDEN = 'hidden';
const EVENT_TYPE_CLICK = 'click';
const HTML_TAG_FORM = 'form';
const AJAX_TYPE_POST = 'POST';
const AJAX_TYPE_GET = 'GET';
const AJAX_DATA_TYPE_JSON = 'json';
const CAPCHA_NEEDED_EVENT = 'captchaNeededEvent';
const DATA_ERR_MSG = 'general-error-message';

/**
 * URLChecker module implementation.
 *
 * @author Nikola Tica
 * @class URLChecker
 * @extends Tc.Module
 */
export default class URLChecker extends Module {
	private $formHolder! : JQuery;
	private $checkedURLHolder! : JQuery;
	private $spinnerHolder! : JQuery;
	private $resultSectionHolder! : JQuery;
	private $resetButton! : JQuery;
	private $form! : JQuery;
	private $input! : JQuery;
	private $submitButton! : JQuery;
	private $blacklistedTitle! : JQuery;
	private $notBlacklistedTitle! : JQuery;
	private $additionalInfoHolder! : JQuery;
	private $additionalInfo! : JQuery;
	private $errorMsgHolder! : JQuery;
	private $errorMsg! : JQuery;
	private $ajaxCaptcha! : JQuery;
	private errorMesage! : string;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @return void
	 */
	public on(callback : Hook) {
		this.$formHolder = this.$ctx.find('.form-holder');
		this.$checkedURLHolder = this.$ctx.find('.checked-url-holder');
		this.$spinnerHolder = this.$ctx.find('.spinner-holder');
		this.$resultSectionHolder = this.$ctx.find('.result-display-holder');
		this.$resetButton = this.$ctx.find('.reset-url-checker');
		this.$form = this.$formHolder.find(HTML_TAG_FORM);
		this.$input = this.$ctx.find('#url');
		this.$submitButton = this.$ctx.find('.check-url-button');
		this.$blacklistedTitle = this.$ctx.find('.blacklisted-title-holder');
		this.$notBlacklistedTitle = this.$ctx.find('.not-blacklisted-title-holder');
		this.$additionalInfoHolder = this.$ctx.find('.blacklisted-reasone-holder');
		this.$additionalInfo = this.$ctx.find('.blacklisted-reasone');
		this.$errorMsgHolder = this.$form.find('.headingError');
		this.$errorMsg = this.$errorMsgHolder.find('.msg');
		this.$ajaxCaptcha = this.$ctx.find('.modAjaxCaptcha');

		this.errorMesage = this.$ctx.data(DATA_ERR_MSG);

		this.reset();

		this.$resetButton.on(EVENT_TYPE_CLICK, this.reset.bind(this));
		this.$submitButton.on(EVENT_TYPE_CLICK, this.submitForm.bind(this));

		$.ajax({
			data: `path=${encodeURIComponent(window.location.pathname)}`,
			dataType: AJAX_DATA_TYPE_JSON,
			success: this.handleCaptchaResult.bind(this),
			type: AJAX_TYPE_GET,
			url: '/etc/swisscom/servlets/public/urlchecker.urlchecker.json',
		});

		callback();
	}
	/**
	 * Handles captcha result
	 */
	private handleCaptchaResult(data : any) {
		if (data.captcha) {
			this.$ajaxCaptcha.trigger(CAPCHA_NEEDED_EVENT);
		}
	}
	/**
	 * Shows URL checker form part
	 */
	private showFormSection() {
		this.$formHolder.removeClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Hides URL checker form part
	 */
	private hideFormSection() {
		this.$formHolder.addClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Shows spinner holder
	 */
	private showSpinner() {
		this.$spinnerHolder.removeClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Hides spinner holder
	 */
	private hideSpinner() {
		this.$spinnerHolder.addClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Shows result section
	 */
	private showResultSection() {
		this.$resultSectionHolder.removeClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Hides result section
	 */
	private hideResultSection() {
		this.$resultSectionHolder.addClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Shows blacklisted title
	 */
	private showBlackListedTitle() {
		this.$blacklistedTitle.removeClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Hides blacklisted title
	 */
	private hideBlackListedTitle() {
		this.$blacklistedTitle.addClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Shows not blacklisted title
	 */
	private showNotBlackListedTitle() {
		this.$notBlacklistedTitle.removeClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Hides not blacklisted title
	 */
	private hideNotBlackListedTitle() {
		this.$notBlacklistedTitle.addClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Shows additional info
	 */
	private showAdditionalInfo() {
		this.$additionalInfoHolder.removeClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Hides additional info
	 */
	private hideAdditionalInfo() {
		this.$additionalInfoHolder.addClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Shows form error message
	 */
	private showFormError() {
		this.$errorMsg.text(this.errorMesage);
		this.$errorMsgHolder.removeClass(CSS_CLASS_HIDDEN);
	}
	/**
	 * Hides form error message
	 */
	private hideFormError() {
		this.$errorMsgHolder.addClass(CSS_CLASS_HIDDEN);
		this.$errorMsg.text('');
	}
	/**
	 * Populates the checked url holder
	 */
	private populateCheckedURLHolder(url : string) {
		this.$checkedURLHolder.text(url);
	}
	/**
	 * Populates additional info
	 */
	private populateadditionalInfo(text = '') {
		this.$additionalInfo.empty().html(text);
	}
	/**
	 * Resets module
	 */
	private reset() {
		this.hideFormError();
		this.showFormSection();
		this.hideSpinner();
		this.hideResultSection();
		this.hideAdditionalInfo();
		this.hideBlackListedTitle();
		this.hideNotBlackListedTitle();

		this.$input.val('');
		this.populateCheckedURLHolder('');
		this.populateadditionalInfo('');
	}
	/**
	 * Submits form
	 */
	private submitForm(evt : JQuery.ClickEvent) {
		const formApi = this.$form.parent().data('form-api');
		const invalidateFieldsNum = formApi.validateForm();
		const mod = this;

		evt.preventDefault();

		if (!invalidateFieldsNum) {
			this.hideFormSection();
			this.showSpinner();
			$.ajax({
				data: `${this.$form.serialize()}&path=${encodeURIComponent(window.location.pathname)}`,
				dataType: AJAX_DATA_TYPE_JSON,
				success: this.handleSubmitResult.bind(this),
				type: AJAX_TYPE_POST,
				url: '/etc/swisscom/servlets/public/urlchecker.urlchecker.json',
				error(data : JQuery.jqXHR) {
					mod.handleInvalidResponse(data.responseJSON);
				},
			});
		}
	}
	/**
	 * Handles submit result
	 */
	private handleSubmitResult(data : IServerResponse) {
		if(!data.success) {
			this.handleInvalidResponse(data);
		} else {
			this.handleSuccessResponse(data.data);
		}
	}
	/**
	 * Handles invalid response
	 */
	private handleInvalidResponse(data : { data : any }) {
		if (data.data.captcha) {
			this.$ajaxCaptcha.trigger(CAPCHA_NEEDED_EVENT);
		}
		this.errorMesage = data.data.description ? data.data.description : this.$ctx.data(DATA_ERR_MSG);
		this.showFormError();
		this.hideSpinner();
		this.showFormSection();
	}
	/**
	 * Handles success response
	 */
	private handleSuccessResponse(data : IURLCheckerResponse) {
		if (data.captcha) {
			this.$ajaxCaptcha.trigger(CAPCHA_NEEDED_EVENT);
		}
		const inputVal = this.$input.val();
		this.populateCheckedURLHolder(String(inputVal));
		if(data.blocked) {
			this.showBlackListedTitle();
			this.hideNotBlackListedTitle();
			this.populateadditionalInfo(data.additionalInfo);
			if (data.additionalInfo) {
				this.showAdditionalInfo();
			} else {
				this.hideAdditionalInfo();
			}
		} else {
			this.hideBlackListedTitle();
			this.showNotBlackListedTitle();
			this.hideAdditionalInfo();
		}
		this.hideSpinner();
		this.showResultSection();
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/cleanpipe/Tc.Module.URLChecker.ts